import { UpdateLayerComponent } from './update-layer/update-layer.component'
import { CreateLayerComponent } from './create-layer/create-layer.component'
import { LayerComponent } from './layer.component'
import { MainLayoutComponent } from '@components/main-layout/main-layout.component'
import { Routes } from '@angular/router'
import { AuthGuard } from 'src/app/guards/auth.guard'
import { NgxPermissionsGuard } from 'ngx-permissions'

export const layerRoutes: Routes = [
  {
    path: 'admin/layer',
    component: MainLayoutComponent,
    canActivate: [AuthGuard, NgxPermissionsGuard],
    data: {
      permissions: {
        only: 'SYSTEM_CONFIGURATION_PANEL',
        redirectTo: '/',
      },
    },
    children: [
      {
        path: '',
        component: LayerComponent,
        data: {
          permissions: {
            only: 'SYSTEM_CONFIGURATION_PANEL',
            redirectTo: '/',
          },
        },
      },
      {
        path: 'create',
        component: CreateLayerComponent,
        data: {
          permissions: {
            only: 'SYSTEM_CONFIGURATION_PANEL',
            redirectTo: '/',
          },
        },
      },
      {
        path: ':id/update',
        component: UpdateLayerComponent,
        data: {
          permissions: {
            only: 'SYSTEM_CONFIGURATION_PANEL',
            redirectTo: '/',
          },
        },
      },
    ],
  },
]
